import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Grid,
  Typography,
} from '@material-ui/core';

import logo from '../../assets/img/logo-NokianTyres.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: '100%'
  },
  formWrapper: {
    width: '368px',
    textAlign: 'center',
    padding: theme.spacing(2, 1)
  },
  title: {
    color: theme.palette.primary.main,
    fontFamily: theme.brandFont,
    fontSize: '18px',
    fontWeight: 'bold',
    letterSpacing: '1.5px',
    margin: theme.spacing(3, 0, 2, 0),
    textTransform: 'uppercase'
  }
}));

const MinimalFormPage = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container justify="center" alignItems="center" className={classes.wrapper}>
      <Grid container direction="column" className={classes.formWrapper} component="main">

        <img src={logo} alt="Nokian Tyres logo" />

        <Typography variant="h4" component="h1" className={classes.title}>{t('app:name')}</Typography>

        {props.children}
      </Grid>
    </Grid>
  );
};

MinimalFormPage.propTypes = {
  children: PropTypes.node
}

export default MinimalFormPage;
